import React from "react";

const BandSection = () => {
  return (
    <section className="career-band">
      <div className="container career-band-inner">
        <div>
          <p className="eyebrow">Candidate Support</p>
          <h2>Every role connects to a managed search process.</h2>
          <p>
            Candidates can prepare their profile, referral source, resume, and
            introduction for review by the Lovapex team.
          </p>
        </div>
        <a
          className="button button-secondary button-md"
          href="/contact"
          data-discover="true"
        >
          Contact Careers
        </a>
      </div>
    </section>
  );
};

export default BandSection;
